import PropTypes from 'prop-types';
import React from 'react';
import useScrollProgress from '../hooks/useScrollProgress';

ScrollProgress.propTypes = {
  className: PropTypes.string,
};

function ScrollProgress({ className }) {
  const scrollProgress = useScrollProgress(className);

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: `${scrollProgress}%`,
        height: '5px',
        backgroundColor: '#2c78f6',
        zIndex: 99,
      }}
    />
  );
}

export default ScrollProgress;
